import 'css-chunksrc/client/pages/searchPage/filters/typesFilter/styles.scss';export default {
  "typesFilter": "_typesFilter_1ydxg_1",
  "type": "_type_1ydxg_1",
  "name": "_name_1ydxg_13",
  "selected": "_selected_1ydxg_23"
};